import { BotProviderPage } from '@/Workspaces/BotProvider/BotProviderPage'
import { ChatBotHistoryPage } from '@/Workspaces/ChatBotHistory/Index'
import { createFileRoute, useParams } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/workspace/$workspaceId/botProvider/$botProviderId/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <BotProviderPage />
}
